import { createToast, error, info, success, warning } from './NotificationService';
export function getTestButtonProps() {
    return {
        buttonProps: {
            label: 'Test button',
            unelevated: true,
        },
        buttonListeners: {
            click: () => {
                const accessor = createToast({ message: 'Test button clicked', type: 'success' });
                setTimeout(() => accessor && accessor.close(), 2000);
                setTimeout(() => {
                    success('Test button clicked');
                    setTimeout(() => {
                        error('Test button clicked');
                        setTimeout(() => {
                            info('Test button clicked');
                            setTimeout(() => {
                                warning('Test button clicked');
                            }, 2000);
                        }, 2000);
                    }, 2000);
                }, 2000);
            }
        }
    };
}
